// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1TDTP","validationTips":"StatementDescriptor_validationTips__2vBlw"};